import { useStoreState } from "ezStore";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { DataFormat } from "utils";
import { useApolloClient } from "@apollo/client";
import { GetCostTypesDocument, GetCostTypesQuery } from "__generated__/view/costtypes/graphql/queries.generated";
import { ChildPropsFromArray } from "types/commons";

export type CostTypeSelectOption = ChildPropsFromArray<GetCostTypesQuery, "costTypes">;

const CostTypeSelect = ({ ...rest }: Omit<SelectProps<CostTypeSelectOption, false>, "fetchOptions">) => {
	const client = useApolloClient();

	const { locale } = useStoreState(store => store.session);

	const onFetchOptions = async() => {

		const response = await client.query({
			query: GetCostTypesDocument,
		});

		return {
			options: response.data?.costTypes ?? [],
			totalResults: response.data?.costTypes?.length ?? 0,
		};
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => DataFormat.costType(option, locale)} />
	);
};

export default CostTypeSelect;
